import React from "react";
import { useCart } from "~/hooks/cartContext";

function CartButton({
  mobile = false,
  mobileBar = false,
}: {
  mobile?: boolean;
  mobileBar?: boolean;
}) {
  const { items } = useCart();
  const totalItems = items.reduce((sum, i) => sum + i.quantity, 0);

  let className = "Header-nav-item";
  if (mobile) {
    className = "Mobile-overlay-nav-item";
  }
  if (mobileBar) {
    className = "Mobile-bar-action";
  }

  return (
    <button
      className={className}
      onClick={() => document.dispatchEvent(new Event("toggle-cart"))}
    >
      🛒 {totalItems > 0 && `(${totalItems})`}
    </button>
  );
}

export default CartButton;
